import { render, staticRenderFns } from "./List-colaborador.vue?vue&type=template&id=39e210b7&scoped=true&"
import script from "./List-colaborador.vue?vue&type=script&lang=js&"
export * from "./List-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./List-colaborador.vue?vue&type=style&index=0&id=39e210b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e210b7",
  null
  
)

export default component.exports